import { useNavigate } from 'react-router';

import { Button } from '@/components/ui';

export function NotFoundPage() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center text-center">
      <p className="font-mono text-sm text-content-subtle">404</p>
      <h1 className="mt-2 text-lg font-semibold text-content">Page not found</h1>
      <p className="mt-1 max-w-sm text-sm text-content-muted">
        The page you are looking for does not exist or has been moved.
      </p>
      <Button
        variant="primary"
        size="md"
        className="mt-5"
        onClick={() => {
          void navigate('/');
        }}
      >
        Back to overview
      </Button>
    </div>
  );
}
